import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/Login.css";
import {
  FaUser,
  FaEye,
  FaEyeSlash,
  FaLock
} from "react-icons/fa";

function Login() {
  const navigate = useNavigate();

  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const showTopMessage = (text) => {
    setMessage(text);

    setTimeout(() => {
      setMessage("");
    }, 4000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const response = await fetch("/backend/login.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          login_id: loginId,
          password: password
        })
      });

    const rawText = await response.text();
    console.log("LOGIN RAW RESPONSE:", rawText);
    
    let data;
    
    try {
      data = JSON.parse(rawText);
    } catch (error) {
      if (rawText.includes("Invalid Member ID/Email or password")) {
        showTopMessage("Invalid Member ID/Email or password");
      } else if (rawText.includes("Login successful")) {
        showTopMessage("Login successful");
      } else {
        showTopMessage(rawText || "Invalid server response");
      }
      return;
    }

      if (data.success) {
        localStorage.setItem("user", JSON.stringify(data.user || {}));
        showTopMessage("Login successful");

        setTimeout(() => {
          navigate("/dashboard");
        }, 1200);
      } else {
        showTopMessage(data.message || "Login failed");
      }
    } catch (error) {
      showTopMessage("Unable to connect to server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {message && <div className="top-alert">{message}</div>}

      <div className="login-page">
        <div className="login-layout">
          <div className="login-left">
            <div className="brand-badge">Mr.Fillo</div>
            <h1>Welcome back</h1>
            <p>
              Sign in to continue your Mr.Fillo journey with secure access,
              smooth login, and a modern account experience.
            </p>

            <div className="left-feature-list">
              <div className="left-feature-card">
                <h3>Flexible login</h3>
                <p>Use either your Member ID or Email Address to sign in.</p>
              </div>

              <div className="left-feature-card">
                <h3>Secure access</h3>
                <p>Your account is protected with reliable login validation.</p>
              </div>

              <div className="left-feature-card">
                <h3>Fast experience</h3>
                <p>Responsive and clean login flow for desktop and mobile.</p>
              </div>
            </div>
          </div>

          <div className="login-right">
            <div className="login-card">
              <div className="auth-header">
                <h1>Login</h1>
                <p>Login with Member ID or Email</p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="input-group">
                  <FaUser className="input-icon" />
                  <input
                    type="text"
                    placeholder="Member ID or Email Address"
                    value={loginId}
                    onChange={(e) => setLoginId(e.target.value)}
                    required
                  />
                </div>

                <div className="password-field">
                  <FaLock className="password-lock-icon" />
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <span
                    className="eye-icon"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>

                <div className="login-options">
                  <span className="forgot-link">Forgot password?</span>
                </div>

                <button type="submit" disabled={loading}>
                  {loading ? "Signing in..." : "Login"}
                </button>
              </form>

              <div className="login-footer">
                Don&apos;t have an account?{" "}
                <span onClick={() => navigate("/signup")}>Create Account</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;